import { Card, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Rest from "../../../../libraries/Rest";
import Alert from "../../../../libraries/Alert";
import * as Components from "../../../../components/Components";
import Validator from "../../../../libraries/Validator";

function CompanyShiftForm() {
    const { companyId, id } = useParams();
    const navigate = useNavigate();
    const rest = new Rest();

    const isCreate = id?.toLowerCase() === 'add' ? true : false;

    /**
     * Init validator of payload
     */
    const validator = new Validator({
        code: { required: true },
        name: { required: true },
        time_in: { required: true },
        time_out: { required: true },
    });

    /**
     * Init states
     */
    const rootPath = `/companies/shifts/${companyId}`;
    const endpoint = `/companies/shifts/${companyId}`;

    let [payload, setPayload] = useState({
        code: null,
        name: null,
        time_in: null,
        time_out: null,
        description: null,
    });

    /**
     * First init function
     */
    const getDataById = async () => {
        const response = await rest.get(`${endpoint}/${id}`);
        if (response?.data?.data !== undefined) {
            const data = response.data.data;
            setPayload({
                code: data?.code,
                name: data?.name,
                time_in: `${data?.time_in}:00`,
                time_out: `${data?.time_out}:00`,
                description: data?.description,
            });
        } else {
            Alert.showMessage('Error', 'error', 'Data is not found');
            navigate(rootPath);
        }
    }

    useEffect(() => {
        async function __init() {
            Alert.showLoading();
            if (!isCreate) await getDataById();
            Alert.close();
        }
        __init();
    }, []);


    /**
     * Action handlers
     */
    const updatePayload = (field, value) => {
        setPayload({ ...payload, [field]: value });
    }

    const submit = async () => {
        /**
         * Validate input
         */
        const errMessages = validator.validate(payload);
        if (errMessages.length > 0) {
            let errMessageStrings = ``;
            for (let i = 0; i < errMessages.length; i++) {
                errMessageStrings += `${errMessages[i]}<br />`;
            }
            return Alert.showMessage(`Invalid input`, `warning`, errMessageStrings);
        }

        /**
         * Submit action
         */
        Alert.showConfirm({
            url: endpoint + (!isCreate ? `/${id}` : ``),
            method: isCreate ? 'POST' : 'PUT',
            data: payload,
        }).then((result) => {
            if (result.isConfirmed) {
                if (result?.value?.success) {
                    Alert.showMessage('Success', 'success', result?.value?.data?.message);
                    navigate(rootPath);
                } else {
                    Alert.showMessage('Failure', 'error', result?.value?.message);
                }
            }
        });
    }

    /**
     * Rendering DOM
     */
    return (
        <div>
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <ol className="breadcrumb fs-sm mb-1">
                        <li className="breadcrumb-item">
                            <Link to="/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/companies">List companies</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to={rootPath}>List shifts</Link>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Form {isCreate ? 'create' : 'edit'}
                        </li>
                    </ol>
                </div>
            </div>

            <Row className="g-3">
                <Col xl="12">
                    <Card className="card">
                        <Card.Header className="bg-primary">
                            <Card.Title
                                as="label"
                                className="fs-sm fw-medium mb-1 text-white"
                            >
                                Form {isCreate ? 'create' : 'edit'} shift
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <Link to={rootPath} className="btn btn-sm btn-warning text-white">
                                <i className="ri-arrow-left-line"></i> Back
                            </Link>
                            &nbsp;
                            <button className="btn btn-sm btn-primary" onClick={submit}>
                                <i className="ri-check-line"></i> Save
                            </button>
                            <br /><br />
                            <Row className="g-3">
                                <Col sm="3">
                                    <Components.Input
                                        type="text"
                                        name="code"
                                        label="Code"
                                        placeholder="e.g: Shift Code"
                                        defaultValue={payload.code}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="3">
                                    <Components.Input
                                        type="text"
                                        name="name"
                                        label="Name"
                                        placeholder="e.g: Shift Pagi"
                                        defaultValue={payload.name}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="3">
                                    <Components.Input
                                        type="time"
                                        name="time_in"
                                        label="Time IN"
                                        placeholder="e.g: 07:00"
                                        defaultValue={payload.time_in}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="3">
                                    <Components.Input
                                        type="time"
                                        name="time_out"
                                        label="Time OUT"
                                        placeholder="e.g: 16:00"
                                        defaultValue={payload.time_out}
                                        change={updatePayload}
                                    />
                                </Col>
                                <Col sm="12">
                                    <Components.Input
                                        type="text"
                                        name="description"
                                        label="Description"
                                        placeholder="Description"
                                        defaultValue={payload.description}
                                        change={updatePayload}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default CompanyShiftForm;